import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/axios";
import { toast } from "react-toastify";

export const fetchCategories = createAsyncThunk(
  "category/fetchCategories",
  async () => {
    const response = await apiService.get("/category/getAllCategory",
      {},
      { skipErrorToast: true }
    );
    return response.data;
  }
);

export const addCategory = createAsyncThunk(
  "category/addCategory",
  async (categoryData) => {
    const response = await apiService.post("/category/create", categoryData);
    toast.success("Category added successfully");
    return response.data.newCategory;
  }
);

export const updateCategory = createAsyncThunk(
  "category/updateCategory",
  async ({ categoryId, updateData }) => {
    const response = await apiService.put("/category/update", {
      categoryId,
      ...updateData,
    });
    toast.success("Category updated successfully");
    return response.updatedCategory;
  }
);

export const deleteCategory = createAsyncThunk(
  "category/deleteCategory",
  async (categoryId) => {
    await apiService.put("/category/deleteCategory", {
      categoryId,
      isDelete: true,
    });
    toast.success("Category deleted successfully");
    return categoryId;
  }
);

export const toggleSwitch = createAsyncThunk(
  "category/toggleSwitch",
  async (data) => {
    const response = await apiService.put("/category/update", {
      categoryId: data?.id,
      isActive: data?.isActive,
    });
    return response.updatedCategory;
  }
);

export const toggleSubcategorySwitch = createAsyncThunk(
  "category/toggleSubcategorySwitch",
  async (data) => {
    const response = await apiService.put("/category/updateSubCategoryStatus", {
      categoryId: data?.categoryId,
      subCategoryId: data?.subCategoryId,
      isActive: data?.isActive,
    });
    return response.updatedCategory;
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        state.categories.push(action.payload);
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        const index = [...state.categories].findIndex(
          (cat) => cat._id === action.payload._id
        );
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter(
          (cat) => cat._id !== action.payload
        );
      })
      .addCase(toggleSwitch.fulfilled, (state, action) => {
        const index = [...state.categories].findIndex(
          (cat) => cat._id === action.payload._id
        );
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      })
      .addCase(toggleSubcategorySwitch.fulfilled, (state, action) => {
        const index = [...state.categories].findIndex(
          (cat) => cat._id === action.payload._id
        );
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      });
  },
});

export const { } = categorySlice.actions;
export default categorySlice.reducer;
